// EditJobForm.tsx
import React from 'react';
import { Job } from '../../types/job';
import UpsertJobForm from './UpsertJobForm';
import { JobUpsertParams } from '../../types/job';
import { useTranslation } from 'react-i18next';

interface EditJobFormProps {
  job: Job;
  onUpdateJob: (updatedParams: JobUpsertParams) => Promise<void>;
  onClose?: () => void;
  onCancelChange?: () => void;
  error?: string | null;
  submitButtonLabel?: string;
  submittingButtonLabel?: string;
}

const EditJobForm: React.FC<EditJobFormProps> = ({
  job,
  onUpdateJob,
  onCancelChange,
  error,
  onClose,
  submitButtonLabel,
  submittingButtonLabel,
}) => {
  const { t } = useTranslation(['jobs', 'common']);

  const jobParams: JobUpsertParams = {
    title: job.title,
    description: job.description,
    onSite: job.on_site,
    startDate: job.start_date || '',
    endDate: job.end_date || '',
    languages: job.languages,
    city: job.city,
    requiredServices: job.required_services,
    budgetRange: job.budget_range,
    shadowRecruiterId: job.is_shadow_recruiter ? (job.shadow_recruiter_id ?? null) : null,
  };

  return (
    <UpsertJobForm
      submitButtonLabel={submitButtonLabel ?? t('save_and_publish', { ns: 'jobs' })}
      submittingButtonLabel={
        submittingButtonLabel ?? t('common:form_actions.saving', { ns: 'common' })
      }
      cancelChangesText={t('remove_offer', { ns: 'jobs' })}
      secondaryButtonLabel={t('cancel_changes', { ns: 'jobs' })}
      jobParams={jobParams}
      error={error}
      onCreateJob={onUpdateJob}
      onSecondaryButtonClick={onClose}
      onCancelChange={onCancelChange}
    />
  );
};

export default EditJobForm;
